// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    MessageSquareQuote,
    MessageSquareReply,
    MessageSquareShare,
    MessageSquareText,
    MessageSquareWarning,
    MessageSquareX,
    MessagesSquare,
    Metronome,
    Mic,
    MicAudioLines,
    MicOff,
    MicSignal,
    MicVocal,
    Microchip,
    Microscope,
    Microwave,
    MidiPort,
    Milestone,
    Milk,
    MilkOff,
    Minimize,
    Minimize2,
    Minus,
    MirrorRectangular,
    MirrorRound,
    Monitor,
    MonitorCheck,
    MonitorCloud,
    MonitorCog,
    MonitorDot,
    MonitorDown,
    MonitorOff,
    MonitorPause,
    MonitorPlay,
    MonitorSmartphone,
    MonitorSpeaker,
    MonitorStop,
    MonitorUp,
    MonitorX,
    Moon,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "message-square-quote" through "moon", inclusive. */
const shard: Record<string, LucideIcon> = {
    "message-square-quote": MessageSquareQuote,
    "message-square-reply": MessageSquareReply,
    "message-square-share": MessageSquareShare,
    "message-square-text": MessageSquareText,
    "message-square-warning": MessageSquareWarning,
    "message-square-x": MessageSquareX,
    "messages-square": MessagesSquare,
    metronome: Metronome,
    mic: Mic,
    "mic-audio-lines": MicAudioLines,
    "mic-off": MicOff,
    "mic-signal": MicSignal,
    "mic-vocal": MicVocal,
    microchip: Microchip,
    microscope: Microscope,
    microwave: Microwave,
    "midi-port": MidiPort,
    milestone: Milestone,
    milk: Milk,
    "milk-off": MilkOff,
    minimize: Minimize,
    "minimize-2": Minimize2,
    minus: Minus,
    "mirror-rectangular": MirrorRectangular,
    "mirror-round": MirrorRound,
    monitor: Monitor,
    "monitor-check": MonitorCheck,
    "monitor-cloud": MonitorCloud,
    "monitor-cog": MonitorCog,
    "monitor-dot": MonitorDot,
    "monitor-down": MonitorDown,
    "monitor-off": MonitorOff,
    "monitor-pause": MonitorPause,
    "monitor-play": MonitorPlay,
    "monitor-smartphone": MonitorSmartphone,
    "monitor-speaker": MonitorSpeaker,
    "monitor-stop": MonitorStop,
    "monitor-up": MonitorUp,
    "monitor-x": MonitorX,
    moon: Moon,
};

export default shard;
